module.exports = __webpack_public_path__ + "static/img/roudmap.6b13b59.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/roudmap.gif
// module id = //YP
// module chunks = 56